import Paper from '@mui/material/Paper';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';
import AutoAwesomeOutlinedIcon from '@mui/icons-material/AutoAwesomeOutlined';
import CheckCircleRoundedIcon from '@mui/icons-material/CheckCircleRounded';
import { CHECK_LABELS } from './uavsMeta';
import { useTokens } from '../primitives';

// "Improvements we've made for you": the applied AI fixes (AuditFixApplication
// artifacts) that will show up as score gains on the next scheduled scan. This
// is the proof-of-value surface for the done-for-you loop. Hidden when there
// are none, so it never nags lower tiers (who have no applied fixes).
export default function FixesDoneCard({ fixes = [] }) {
  const t = useTokens();
  const applied = (Array.isArray(fixes) ? fixes : []).filter(
    (f) => f.status === 'applied'
  );
  if (applied.length === 0) return null;

  return (
    <Paper
      elevation={0}
      sx={{
        p: 2.5,
        mb: 3,
        borderRadius: 3,
        border: '1px solid',
        borderColor: t.purpleBorder,
        bgcolor: t.purpleBg,
      }}
    >
      <Stack direction="row" alignItems="center" spacing={1} sx={{ mb: 0.5 }}>
        <AutoAwesomeOutlinedIcon sx={{ color: t.purple, fontSize: 20 }} />
        <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
          Improvements we made for you
        </Typography>
      </Stack>
      <Typography variant="body2" sx={{ color: 'text.secondary', mb: 1.5 }}>
        These show up as score gains on your next scan.
      </Typography>
      <Stack spacing={1}>
        {applied.slice(0, 8).map((f) => (
          <Stack
            key={f._id}
            direction="row"
            alignItems="flex-start"
            spacing={1}
          >
            <CheckCircleRoundedIcon
              sx={{ fontSize: 18, color: 'success.main', mt: 0.1 }}
            />
            <Box>
              <Typography variant="body2" sx={{ fontWeight: 600 }}>
                {f.proposal?.title || CHECK_LABELS[f.checkKey] || f.checkKey}
              </Typography>
              {f.proposal?.summary ? (
                <Typography variant="caption" sx={{ color: 'text.secondary' }}>
                  {f.proposal.summary}
                </Typography>
              ) : null}
            </Box>
          </Stack>
        ))}
      </Stack>
    </Paper>
  );
}
